import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#flame-clip0_2244_663)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "m4.48 16.662-.001-.006a8.8 8.8 0 0 1-.03-2.731q.046.048.094.095a2.356 2.356 0 0 0 4.012-1.739 10.2 10.2 0 0 1 4.121-8.464 11.38 11.38 0 0 0 3.097 8.155 2.356 2.356 0 0 0 3.367.062l.075-.075.012-.011q.165-.165.315-.342a7.7 7.7 0 0 1 .432 3.827 5.9 5.9 0 0 1-1.398 3.05c-.262.301-.51.62-.727.903a5.5 5.5 0 0 1-2.162 1.677c.39-.824.532-1.767.404-2.745q-.18-1.403-1.64-3.59a.235.235 0 0 0-.414.044q-.739 1.875-1.715 1.344-.995-.543-1.359-3.757a.236.236 0 0 0-.42-.117q-2.653 3.45-2.653 5.76c0 .985.157 1.889.44 2.668-1.11-.492-2.093-1.164-2.87-2.005a3.9 3.9 0 0 1-.98-2.003m-2.325.386a11.13 11.13 0 0 1 1.03-6.848l.813-1.628a.58.58 0 0 1 .663-.31.59.59 0 0 1 .453.573v.9a3.65 3.65 0 0 0 1.085 2.61 12.6 12.6 0 0 1 .203-2.606v-.004A12.6 12.6 0 0 1 8.35 4.977 12.56 12.56 0 0 1 14.317.263l.005-.001.064-.024.536-.202a.594.594 0 0 1 .784.437.6.6 0 0 1-.031.334 9 9 0 0 0-.226.631l-.006.018q-.14.445-.232.898l-.01.051-.005.019-.005.028a9.02 9.02 0 0 0 1.528 6.971l.03.042q.339.467.738.89l.076-.075a3.06 3.06 0 0 0 .593-3.496l-.012-.025-.007-.014a.589.589 0 0 1 1.03-.569l1.813 3.022a10.04 10.04 0 0 1 1.327 6.566 8.3 8.3 0 0 1-1.955 4.268c-.21.24-.42.509-.633.787-1.674 2.185-4.34 3.223-7.091 3.18-.34-.006-.721-.035-1.12-.08-2.914-.325-5.79-1.5-7.779-3.655a6.25 6.25 0 0 1-1.574-3.216",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "flame-clip0_2244_663" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }